import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';

import { AuthService } from '../services/auth.service';
import { CorretoraService } from '../services/corretora.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-corretora-edit',
  templateUrl: './corretora-edit.component.html',
  styleUrls: ['./corretora-edit.component.css'],
  animations: [loadingFade]
})
export class CorretoraEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public corretora_id = null;

  public formCorretora: FormGroup;
  public veiculo_array: NgOption[] = [];

  public qtde_char_descricao = 0;

  constructor(private authSvc: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private corretoraSvc: CorretoraService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.criaForm();

    this.loading = true;

    this.route.params.subscribe(params => {
      if (params.id) {
        this.corretora_id = params.id;
        // pega dados a partir do id
        this.corretoraSvc.getCorretora(params.id).then((data: any) => {
          this.preencheForm({
            corretora_id: data.corretora_id,
            usuario_id: this.authSvc.getUsuarioId(),
            corretora_nome: data.corretora_nome,
            corretora_email: data.corretora_email,
            corretora_tel1: data.corretora_tel1,
            corretora_tel2: data.corretora_tel2,
            corretora_tel3: data.corretora_tel3,
          });

          if (data.corretora_descricao)
            this.qtde_char_descricao = data.corretora_descricao.length;

          this.loading = false;
        });
      }
      else {
        this.loading = false;
      }
    });
  }

  criaForm() {
    this.formCorretora = this.fb.group({
      corretora_id: null,
      usuario_id: this.authSvc.getUsuarioId(),
      corretora_nome: [null, Validators.required],
      corretora_email: null,
      corretora_tel1: null,
      corretora_tel2: null,
      corretora_tel3: null,
    });
  }

  preencheForm(dados) {
    this.formCorretora.setValue(dados);
  }

  enviaCorretora() {
    if (this.formCorretora.valid) {
      this.submitting = true;

      let toSend = this.formCorretora.value;
      if (this.corretora_id === null) { // criar
        this.corretoraSvc.criaCorretora(toSend).then((data) => {
          Swal.fire({
            type: 'success',
            title: 'Corretora cadastrada com sucesso!',
            onClose: () => {
              this.router.navigate(['home/corretora']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
        });
      }
      else { // editar
        this.corretoraSvc.editaCorretora(toSend).then((data) => {
          Swal.fire({
            type: 'success',
            title: 'Corretora alterada com sucesso!',
            onClose: () => {
              this.router.navigate(['home/corretora']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
        });
      }
    }
    else {
      for (let field in this.formCorretora.controls) {
        let campo = this.formCorretora.get(field);
        campo.markAsTouched();
      }
      this.submitting = false;
      Swal.fire({
        type: 'error',
        title: 'Atenção!',
        text: 'Verifique os campos obrigatórios e tente novamente.'
      });
    }
  }

  invalid(nome) {
    let input = this.formCorretora.get(nome);
    return input.touched && input.invalid;
  }
}
